// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vc-container[data-v-07b9aadd]{background-color:var(--color-divider);border-color:var(--color-divider)}.btn-common[data-v-07b9aadd]{background-color:var(--color-surface)}", ""]);
// Exports
module.exports = exports;
